import React, { useContext, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useIntl, useToggle, useOnClickOutside } from 'hooks'
import { format } from 'utils/datetime'
import { CollectionContext } from 'features/surgical-cloud/PatientsCollections'
import { collectionSelector } from 'features/collections-list/collectionSlice'
import ContextMenu from 'components/ContextMenu'
import './index.css'

const CollectionDetailsHeader = ({ contextMenu, data }) => {
    const { t } = useIntl()
    const { isOpen, onClose, onToggle } = useToggle(false)
    const { collectionId } = useContext(CollectionContext)
    const collectionFromSelector = useSelector(state =>
        collectionSelector.selectById(state, collectionId)
    )
    const collection = data || collectionFromSelector

    const myRef = useRef(null)
    useOnClickOutside(myRef, onClose, collectionId)

    return (
        <>
            <div className="patient-details-header">
                <div className="patient-details">
                    <div className="patient-details-stack-wrapper">
                        <div className="patient-stack-name">
                            <span>{collection?.name}</span>
                        </div>
                        <div className="patient-stack-information-wrapper">
                            <div className="patient-stack-information">
                                <div className="gender-icon-wrap">
                                    {format(collection?.updatedDateTime, 'dd/MM/yyyy')}
                                </div>
                                <div className="custom-divider-sm"></div>
                                <div className="patient-stack-dob-age">
                                    <span>
                                        {collection?.fileCount}{' '}
                                        {collection?.fileCount > 1 ? t('files') : t('file')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {contextMenu && (
                    <div
                        className="header-more-details-wrapper"
                        data-ref={collectionId}
                        onClick={onToggle}
                    >
                        <zui-icon-common-more-centered
                            data-ref={collectionId}
                            style={{ color: '#ffffff' }}
                        ></zui-icon-common-more-centered>
                    </div>
                )}
            </div>
            {contextMenu && isOpen && (
                <ContextMenu ref={myRef} onClick={onClose} options={contextMenu} />
            )}
        </>
    )
}

export default React.memo(CollectionDetailsHeader)
